import { mdiAccountMultipleOutline, mdiOfficeBuilding } from '@mdi/js'

export default [
  {
    title: 'Inn Profile',
    icon: mdiOfficeBuilding,
    to: 'feature-inn-profile-view',
    resource: 'Tenant',
  },
  {
    title: 'Membership',
    icon: mdiAccountMultipleOutline,
    resource: 'Tenant',
    children: [
      {
        title: 'Member List',
        to: 'feature-user-list',
        resource: 'Tenant',
      },
      {
        title: 'Member Reports',
        to: 'feature-user-reports-list',
        resource: 'Tenant',
      },
    ],
  },
]
